import { CustomCheckboxInput, QuestionCard } from '@my/ui'
import { Control, useWatch } from 'react-hook-form'

import { confirmationOptions } from '../data'
import { InputField } from '../helpers/Helper'
import images from '../../../assets/images'

interface LifeStyleProps {
  control: Control<any>
}

export const LifeStyle: React.FC<LifeStyleProps> = ({ control }) => {
  const hasChanges = useWatch({name: "Lifestyle And Spending - Has Changes Anticipated"})
  return (
    <>
      <QuestionCard
        questionGroupTitle="Are there any significant lifestyle changes anticipated in the next 5-10 years (e.g., marriage, children, major purchases)?"
      >
        <CustomCheckboxInput
          options={confirmationOptions}
          control={control}
          name="Lifestyle And Spending - Has Changes Anticipated"
        />

        {hasChanges && <InputField
          control={control}
          name="Lifestyle And Spending - Changes Anticipated"
          placeholder="Please describe."
          label="Please describe."
          height={90}
          multiline
        />}
      </QuestionCard>
      <QuestionCard questionGroupTitle="How do you prioritize and manage your spending?">
        <InputField
          control={control}
          name="Lifestyle And Spending - Prioritize Spending"
          placeholder="Please describe."
          label=""
          height={90}
          multiline
        />
      </QuestionCard>
      <QuestionCard questionGroupTitle="How do you track your spending?">
        <InputField
          control={control}
          name="Lifestyle And Spending - Spending"
          placeholder="Please describe."
          label=""
          height={90}
          multiline
        />
      </QuestionCard>
    </>
  )
}
